/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StudentProgressRow } from './StudentProgressRow';
import {
    StudentProgressRowFromJSON,
    StudentProgressRowFromJSONTyped,
    StudentProgressRowToJSON,
    StudentProgressRowToJSONTyped,
} from './StudentProgressRow';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface WidgetDataStudentsProgressWidgetData
 */
export interface WidgetDataStudentsProgressWidgetData {
    /**
     * 
     * @type {string}
     * @memberof WidgetDataStudentsProgressWidgetData
     */
    $type?: WidgetDataStudentsProgressWidgetDataTypeEnum;
    /**
     * 
     * @type {Array<StudentProgressRow>}
     * @memberof WidgetDataStudentsProgressWidgetData
     */
    items: Array<StudentProgressRow>;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof WidgetDataStudentsProgressWidgetData
     */
    total: ApiUserTasksGetPageParameter;
}


/**
 * @export
 */
export const WidgetDataStudentsProgressWidgetDataTypeEnum = {
    StudentsProgress: 'students-progress'
} as const;
export type WidgetDataStudentsProgressWidgetDataTypeEnum = typeof WidgetDataStudentsProgressWidgetDataTypeEnum[keyof typeof WidgetDataStudentsProgressWidgetDataTypeEnum];


/**
 * Check if a given object implements the WidgetDataStudentsProgressWidgetData interface.
 */
export function instanceOfWidgetDataStudentsProgressWidgetData(value: object): value is WidgetDataStudentsProgressWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    return true;
}

export function WidgetDataStudentsProgressWidgetDataFromJSON(json: any): WidgetDataStudentsProgressWidgetData {
    return WidgetDataStudentsProgressWidgetDataFromJSONTyped(json, false);
}

export function WidgetDataStudentsProgressWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WidgetDataStudentsProgressWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        '$type': json['$type'] == null ? undefined : json['$type'],
        'items': ((json['items'] as Array<any>).map(StudentProgressRowFromJSON)),
        'total': ApiUserTasksGetPageParameterFromJSON(json['total']),
    };
}

export function WidgetDataStudentsProgressWidgetDataToJSON(json: any): WidgetDataStudentsProgressWidgetData {
    return WidgetDataStudentsProgressWidgetDataToJSONTyped(json, false);
}

export function WidgetDataStudentsProgressWidgetDataToJSONTyped(value?: WidgetDataStudentsProgressWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        '$type': value['$type'],
        'items': ((value['items'] as Array<any>).map(StudentProgressRowToJSON)),
        'total': ApiUserTasksGetPageParameterToJSON(value['total']),
    };
}

